import log from 'loglevel';

if (__DEVELOPMENT__ || __STAGING__) {
  log.setLevel('debug');
} else {
  log.setLevel('error');
}

const originalFactory = log.methodFactory;
log.methodFactory = (methodName, logLevel, loggerName) => {
  const rawMethod = originalFactory(methodName, logLevel, loggerName);
  return (...args) => {
    const messages = [];

    const time = new Date();
    messages.push(
      `-- ${time.toLocaleTimeString()} : ${time.getMilliseconds()} --`
    );

    args.forEach(l => {
      messages.push(l);
    });
    rawMethod(...messages);
  };
};
log.setLevel(log.getLevel());
